import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/coupon/background.png';
import _imports_1 from '@/assets/coupon/flower-icon.png';
import _imports_2 from '@/assets/coupon/coupon-colse.png';
const _hoisted_1 = {
  class: "coupon-content"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "bottom",
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "flower",
  src: _imports_1,
  alt: ""
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "每日限量200份，先到先得", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "超值年卡会员优惠券", -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "coupon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lj"
}, "立减"), /*#__PURE__*/_createElementVNode("div", {
  class: "price"
}, "￥100"), /*#__PURE__*/_createElementVNode("div", {
  class: "today"
}, "仅今日有效")], -1);
const _hoisted_7 = {
  class: "timer"
};
const _hoisted_8 = {
  class: "text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ai_dialog = _resolveComponent("ai-dialog");
  return _openBlock(), _createBlock(_component_ai_dialog, _mergeProps({
    ..._ctx.$attrs
  }, {
    class: "coupon-dialog"
  }), {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createTextVNode(" 折扣倒计时： "), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.couponTime), 1)]), _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.getCoupon && _ctx.getCoupon(...args))
    }, "立即领取"), _createElementVNode("img", {
      class: "close",
      src: _imports_2,
      alt: "",
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.close && _ctx.close(...args))
    })])]),
    _: 1
  }, 16);
}